import React, { useEffect, useState } from 'react'
import { useParams, useLocation } from "react-router-dom";
import Header from './header'
import { Alert, Loading } from '../components'
import SidebarLeft from './sidebarLeft'
import { useDispatch, useSelector } from 'react-redux'
import { listarIdiomas, listarProjetos, loading, loged, modalOpen, setDevice, setFilters, setHeigthPage, setInfoGrupo, setInfoProjeto, verificaCreditoConta } from './redux/layoutActions'
import ModalInforme from './modalInforme'
import CentralAjuda from '../modules/centralAjuda/centralAjuda'
import ModalAlerta from './modalAlerta'
import { history } from '../helpers'
import { listarMeusProjetos } from '../modules/meusProjetos/redux/meusProjetosActions'
import Footer from './footer'
import Listar from '../modules/dashboard/listar'



export default ({ children, sidebar }) => { 
  const dispatch = useDispatch()
  const {idProjetos} = useParams()
  const { 
    load, 
    logIn, 
    projeto, 
    projetos,
    grupo,
    grupos,
    sistema,
    usuario,
    filters,
    ciclo,
    device,
    heigthPage,
  } = useSelector(state=> state.layoutState)
  const nls = require(`./nls/${sistema.idioma}.json`)
  const idioma = sistema.idioma
  //console.log("SISTEMA NO COMEÇO COM ID", sistema)
  
  const heigthExec = e=> {
    if (heigthPage.content === 0 || heigthPage.header === 0) {
      const headerH = document.getElementById('box-header')?.offsetHeight
      const contentH = document.getElementById('box-app')?.offsetHeight
      dispatch(setHeigthPage({name: 'header', value: headerH ? headerH : 62}))
      dispatch(setHeigthPage({name: 'content', value: contentH ? contentH : (window.innerHeight + 2)}))
    }
  }

  useEffect(() => {
    heigthExec()
  }, [logIn, sistema, usuario, projetos])

  const heightApp = { height: `calc(${heigthPage.content}px)` }
  const heightContent = { height: `calc(${heigthPage.content}px - ${heigthPage.header}px)` }
  document.body.style.height = heightApp.height;
  
  useEffect(()=> {
    setTimeout(() => {
      dispatch(loged())
    }, 500);
  },[dispatch])

  useEffect(()=> {   
    if (logIn && sistema?.login?.recebePopupBoasVindas) { 
      dispatch(modalOpen('modalInforme'))
    }
  },[logIn])

  useEffect(() => {
    const updateDeviceType = () => {
      const width = window.innerWidth;
      let deviceType = "desktop"
      if (width < 768) {
        deviceType = "mobile"
      } else if (width >= 768 && width < 1024) {
        deviceType = "desktop"
        // deviceType = "tablet"
      }
      if (device !== deviceType) {
        dispatch(setDevice(deviceType))
      }
    };

    updateDeviceType();
    window.addEventListener("resize", updateDeviceType);
    return () => window.removeEventListener("resize", updateDeviceType);
  }, []);
  
  useEffect(()=> {
    if (logIn) {
      dispatch([
        listarIdiomas(sistema),
        verificaCreditoConta()
      ])
    }
  },[logIn])

  useEffect(()=> {
      dispatch(listarMeusProjetos(idProjetos))
  },[usuario])

  useEffect(()=> {
    if (idProjetos && projetos.length) {
      // idProjetos
      const projetoSelected = projetos.find(e=> String(e.idProjeto) === String(idProjetos))
      dispatch(setInfoProjeto(projetoSelected))
      
    }
  },[idProjetos, projetos])

  useEffect(()=> {
    if (!filters?.ciclo?.mesAno && ciclo?.mesAno) {
      dispatch(setFilters({name: 'ciclo', value: ciclo}))
    }
  }, [filters.ciclo, ciclo]) 


//AQUI DEVE VIR JIVOCHAT

useEffect(() => {
  if (logIn) {
    let widgetId = 'xjAybncqgV'; // Default: inglês

    if (sistema.idioma === 'pt-BR') {
      widgetId = 'Lt0CMe6tRp';
    } else if (sistema.idioma === 'esp') {
      widgetId = 'PilIvBFKFd';
    }

    const script = document.createElement('script');
    script.src = `//code.jivosite.com/widget/${widgetId}`;
    script.async = true;
    document.body.appendChild(script);

    //console.log(`✅ JivoChat carregado para idioma ${sistema.idioma}, canal ${widgetId}`);

    return () => {
      // Opcional: Se quiser limpar o script ao deslogar...não funciona...coloquei em logout a opção de 
      //refresh de página que elimina o Jivochat
    };
  }
}, [logIn, sistema.idioma]);


  const teste = "nada"




  if (!logIn) {
    return <Loading title={nls.carregando} />
  }


  return (
    <>
      {load? <Loading title={nls.carregando} />:null}
      <Alert />
      <div id='box-app' className={`box-type-${device}`} style={heightApp}>
        <Header sidebar={sidebar} />
        <div id='box-app-container' style={sidebar?{display: 'flex'}:{}}>
        {sidebar?<SidebarLeft style={heightContent} />:null}
          <section id='box-container' style={heightContent}>
            <div id='box-container-page' style={sidebar?{padding: '10px 30px 30px 30px'}:{}}>
              {/* {device !== 'desktop' ?
                <div className='box-alerta danger'>{nls.mobileMessage}</div>
              :null} */}
              {
                usuario?.permissoes?.VerFazerUpgrade && sistema?.login?.mensagemBannerPromocional ? (
                  <div
                    className='box-alerta danger'
                    onClick={() => history.push(`/accountupgrade`)}
                    dangerouslySetInnerHTML={{
                      __html: `<strong>${sistema?.login?.mensagemBannerPromocional}</strong>`
                    }}
                  />
                ) : null
              }

              {children}
            </div>
          </section>
        </div>
      </div>
      <ModalInforme />
      <CentralAjuda />
      <ModalAlerta/>

      {/* ✅ host global do modal de dashboards */}
      <Listar />
      
    </>
  )
}
// usuario?.permissoes?.VerAdquirirProjetoPronto




